// extracted by mini-css-extract-plugin
export default {"empty":"empty___yfIB7"};